<template>
  <div class="">
    <Header :title="'New Invoice'"></Header>
    <div id="display-pdf" style="display: none"></div>
    <div class="col-md-12 mt-3">
      <div class="row">
        <v-form
          ref="form"
          v-model="valid"
          class="col-xl-6 col-lg-6 col-md-12 col-sm-12 row justify-center"
        >
          <span class="mr-10 text-gray mt-4 font-weight-bold col-md-6">
            Enter or verify invoice information below</span
          >

          <br />
          <div class="col-xl-8 col-lg-12 col-md-12 pb-0">
            <div class="row">
              <label
                for=""
                class="col-md-4 text-xl-right text-lg-right text-md-left"
                >INVOICE NUMBER:</label
              >
              <div class="col-md-5 pt-0">
                <v-text-field
                  solo
                  v-model="invoiceNo"
                  type="number"
                  min="4"
                  :rules="rules"
                ></v-text-field>
              </div>
              <div class="col-md-3 pt-2">
                <span class="text-underline light-blue-text mt-2"
                  >Autogenerate</span
                >
              </div>
            </div>
          </div>

          <div class="col-xl-8 col-lg-12 col-md-12 pb-0">
            <div class="row">
              <label for="" class="col-md-4 text-lg-right text-md-left"
                >BILLING PERIOD:</label
              >
              <div class="col-md-5 pt-0">
                <v-menu
                  ref="menu"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      id="calendar"
                      solo
                      v-model="startDate"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate"></v-date-picker>
                </v-menu>
              </div>
              <div class="col-md-1">
                <svg
                  class="
                    ml-2
                    d-xl-block d-lg-block d-md-none d-sm-none d-xs-none
                  "
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1_11277)">
                    <path
                      d="M21.75 3.75H2.25C1.42157 3.75 0.75 4.42157 0.75 5.25V21.75C0.75 22.5784 1.42157 23.25 2.25 23.25H21.75C22.5784 23.25 23.25 22.5784 23.25 21.75V5.25C23.25 4.42157 22.5784 3.75 21.75 3.75Z"
                      stroke="#707070"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M0.75 9.75H23.25"
                      stroke="#707070"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.75 6V0.75"
                      stroke="#707070"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.25 6V0.75"
                      stroke="#707070"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.625 14.25C5.41789 14.25 5.25 14.0821 5.25 13.875C5.25 13.6679 5.41789 13.5 5.625 13.5"
                      stroke="#707070"
                      stroke-width="1.5"
                    />
                    <path
                      d="M5.625 14.25C5.83211 14.25 6 14.0821 6 13.875C6 13.6679 5.83211 13.5 5.625 13.5"
                      stroke="#707070"
                      stroke-width="1.5"
                    />
                    <path
                      d="M5.625 19.5C5.41789 19.5 5.25 19.3321 5.25 19.125C5.25 18.9179 5.41789 18.75 5.625 18.75"
                      stroke="#707070"
                      stroke-width="1.5"
                    />
                    <path
                      d="M5.625 19.5C5.83211 19.5 6 19.3321 6 19.125C6 18.9179 5.83211 18.75 5.625 18.75"
                      stroke="#707070"
                      stroke-width="1.5"
                    />
                    <path
                      d="M12 14.25C11.7929 14.25 11.625 14.0821 11.625 13.875C11.625 13.6679 11.7929 13.5 12 13.5"
                      stroke="#707070"
                      stroke-width="1.5"
                    />
                    <path
                      d="M12 14.25C12.2071 14.25 12.375 14.0821 12.375 13.875C12.375 13.6679 12.2071 13.5 12 13.5"
                      stroke="#707070"
                      stroke-width="1.5"
                    />
                    <path
                      d="M12 19.5C11.7929 19.5 11.625 19.3321 11.625 19.125C11.625 18.9179 11.7929 18.75 12 18.75"
                      stroke="#707070"
                      stroke-width="1.5"
                    />
                    <path
                      d="M12 19.5C12.2071 19.5 12.375 19.3321 12.375 19.125C12.375 18.9179 12.2071 18.75 12 18.75"
                      stroke="#707070"
                      stroke-width="1.5"
                    />
                    <path
                      d="M18.375 14.25C18.1679 14.25 18 14.0821 18 13.875C18 13.6679 18.1679 13.5 18.375 13.5"
                      stroke="#707070"
                      stroke-width="1.5"
                    />
                    <path
                      d="M18.375 14.25C18.5821 14.25 18.75 14.0821 18.75 13.875C18.75 13.6679 18.5821 13.5 18.375 13.5"
                      stroke="#707070"
                      stroke-width="1.5"
                    />
                    <path
                      d="M18.375 19.5C18.1679 19.5 18 19.3321 18 19.125C18 18.9179 18.1679 18.75 18.375 18.75"
                      stroke="#707070"
                      stroke-width="1.5"
                    />
                    <path
                      d="M18.375 19.5C18.5821 19.5 18.75 19.3321 18.75 19.125C18.75 18.9179 18.5821 18.75 18.375 18.75"
                      stroke="#707070"
                      stroke-width="1.5"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_11277">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
          <div class="col-xl-8 col-lg-12 col-md-12 pb-0">
            <div class="row">
              <label for="" class="col-md-4 text-lg-right text-md-left"
                >CLIENT:</label
              >
              <div class="col-md-5 pt-0">
                <v-select
                  solo
                  v-model="client"
                  :items="clients"
                  item-text="companyName"
                  item-value="id"
                ></v-select>
              </div>
            </div>
          </div>
          <div class="col-xl-8 col-lg-12 col-md-12 pb-0">
            <div class="row">
              <label for="" class="col-md-4 text-lg-right text-md-left"
                >PLAN:</label
              >
              <div class="col-md-5 pt-0">
                <v-select
                  solo
                  :items="clients.planId"
                  v-model="planId"
                ></v-select>
              </div>
            </div>
          </div>
          <div class="col-xl-8 col-lg-12 col-md-12 pb-0">
            <div class="row">
              <label for="" class="col-md-4 text-lg-right text-md-left"
                >TOTAL CHARGE (USD):</label
              >
              <div class="col-md-5 pt-0">
                <v-text-field solo v-model="total"></v-text-field>
              </div>
            </div>
          </div>
        </v-form>
        <v-divider vertical style="margin-top: 80px"></v-divider>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
          <div class="text-gray col-md-12 row">
            <div class="col-xl-4 col-lg-4 col-md-12">
              <span
                class="pointer font-weight-bold"
                :class="tab == 'invoice' ? 'light-blue-text' : 'text-gray'"
                @click="tab = 'invoice'"
                >Invoice</span
              >
              <span class="mr-5 ml-5">|</span>
              <span
                class="pointer font-weight-bold"
                :class="tab == 'members' ? 'light-blue-text' : 'text-gray'"
                @click="tab = 'members'"
                >Members
              </span>
              <small class="text-gray">(optional)</small>
            </div>

            <span
              v-if="tab == 'members'"
              class="col-xl-4 col-lg-4 col-md-12 pt-2"
            >
              <v-text-field
                class="input-control mb-5"
                prepend-inner-icon="mdi-magnify"
                @input="searchMembers"
                light
                dense
                outlined
                placeholder="Search Member List Below"
              ></v-text-field>
            </span>
            <span
              v-if="tab == 'members'"
              class="col-xl-4 col-lg-4 col-md-12 pt-2 pr-0"
              align="end"
            >
              <a
                class="
                  light-blue-text
                  text-underline
                  ml-10
                  mt-10
                  font-weight-bold
                "
                @click="(memberDialog = true), (arrayLength = false)"
              >
                Upload Member List</a
              >
            </span>
          </div>

          <div class="col-md-12">
            <div
              class="col-md-12 original-image-div text-gray"
              v-if="tab != 'members'"
            >
              <div
                v-if="
                  pdfs.length > 0 &&
                  dataComponents &&
                  dataComponents.pdf &&
                  dataComponents.pdf.name &&
                  dataComponents.pdf.name != ''
                "
              >
                File: {{ dataComponents.pdf.name }}
              </div>
              <div v-else class="col-md-12 first">
                <h3>
                  <a
                    class="text-underline light-blue-text"
                    @click="uploadInvoice"
                    >Upload</a
                  >
                  or
                  <a
                    class="text-underline light-blue-text"
                    @click="emailDialog = true"
                    >Email</a
                  >
                  an Invoice
                </h3>
              </div>
              <!-- <div class="col-md-12 second">
                <h4 class="text-underline pointer mr-2 mb-3">Download</h4>
              </div> -->
            </div>
            <div v-else>
              <!-- <div class="col-md-12 original-image-div text-gray">
                <div class="col-md-12 first">
                  <h3 class="text-gray">Show Original Image of Invoice</h3>
                </div>
                <div class="col-md-12 second">
                <h4 class="text-underline pointer mr-2 mb-3">Download</h4>
              </div> 
              </div> -->
              <v-simple-table
                fixed-header
                height="690px"
                class="col-md-12 no-padding"
              >
                <template v-slot:default>
                  <thead>
                    <tr class="">
                      <th class="text-left">MEMBER ID</th>
                      <th class="text-left">SERVICE DATE</th>
                      <th class="text-left">AMOUNT (USD)</th>
                      <th class="text-left">ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="">
                      <td>
                        <v-text-field
                          solo
                          v-model="member.memberId"
                          hide-details
                          class="mt-2 mb-2"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-menu
                          ref="menu"
                          :close-on-content-click="true"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              hide-details
                              v-model="member.serviceDate"
                              class="mt-2 mb-2"
                              solo
                              append-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="member.serviceDate"
                            :max="
                              new Date(
                                Date.now() -
                                  new Date().getTimezoneOffset() * 60000
                              )
                                .toISOString()
                                .substr(0, 10)
                            "
                            min="1950-01-01"
                          ></v-date-picker>
                        </v-menu>
                      </td>

                      <td>
                        <v-text-field
                          solo
                          type="number"
                          class="mt-2 mb-2"
                          hide-details
                          v-model="member.amount"
                        ></v-text-field>
                      </td>
                      <td>
                        <svg
                          class="pointer"
                          @click="addMember"
                          width="37"
                          height="37"
                          viewBox="0 0 37 37"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.0806 8.90926C6.67256 11.2721 5.31328 14.5065 5.3018 17.9009C5.29031 21.2954 6.62756 24.5717 9.01937 27.0092C11.4112 29.4467 14.6616 30.8458 18.0556 30.8986C21.4496 30.9513 24.7092 29.6535 27.1172 27.2907C29.5253 24.9278 30.8846 21.6934 30.8961 18.299C30.9075 14.9046 29.5703 11.6282 27.1785 9.1907C24.7867 6.75317 21.5362 5.35413 18.1422 5.30135C14.7482 5.24857 11.4887 6.54638 9.0806 8.90926V8.90926Z"
                            stroke="#0AAD38"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M10.8614 17.9878L25.3396 18.2129"
                            stroke="#0AAD38"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M18.076 25.3403L18.125 10.8604"
                            stroke="#0AAD38"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </td>
                    </tr>
                  </tbody>

                  <tbody
                    v-for="(item, index) in membersList"
                    :key="'mem_' + index"
                  >
                    <tr>
                      <td>{{ item.memberId }}</td>
                      <td>{{ item.serviceDate }}</td>
                      <td>{{ item.amount }}</td>
                      <td>
                        <a class="text-underline pointer" @click="remove(item)"
                          >Remove</a
                        >
                      </td>
                    </tr>
                  </tbody>

                  <tbody
                    v-for="(item, index) in uploadedExcelItems"
                    :key="'exc_' + index"
                  >
                    <tr>
                      <td v-html="item.memberId ? item.memberId : '/'">
                        {{ item.memberId }}
                      </td>
                      <td>
                        <span
                          v-if="
                            item.serviceYear &&
                            item.serviceMonth &&
                            item.serviceDay
                          "
                        >
                          {{
                            item.serviceYear +
                            "-" +
                            item.serviceMonth +
                            "-" +
                            item.serviceDay
                          }}
                        </span>
                        <span v-else>/</span>
                      </td>
                      <td v-html="item.amount ? item.amount : '/'">
                        {{ item.amount }}
                      </td>
                      <td>
                        <a
                          class="text-underline pointer"
                          @click="removeFromExcel(item)"
                          >Remove</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="gray-top-border">
      <div class="col-md-12" align="end">
        <span
          class="text-gray text-underline mr-10 font-weight-bold pointer"
          @click="$router.push('/solution-vendor/invoices')"
          >Cancel</span
        >
        <span
          class="text-gray text-underline ml-10 mr-10 font-weight-bold pointer"
          @click="submit"
          >Submit Charges</span
        >
      </div>
    </div>

    <v-dialog v-model="memberDialog" persistent max-width="800px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-col md="12" cols="12" class="justify-center align-center">
              <div class="row col-md-12 font">
                <h3 class="ml-3">Upload a List of Plan Members</h3>
              </div>
              <div class="row text-center justify-center upload-box">
                <div
                  class="col-md-10 upload-provider-box pointer"
                  style="padding-bottom: 30px; padding-top: 50px"
                  @click="addItemExcel"
                >
                  <input
                    ref="fileInput"
                    type="file"
                    style="display: none"
                    @change="uploadExcel"
                  />
                  <svg
                    width="100"
                    height="100"
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M90.2135 56.7417C86.921 54.5234 83.1435 53.1503 79.208 52.7413C75.2726 52.3322 71.2979 52.8996 67.6281 54.3942C63.9583 55.8889 60.704 58.2658 58.147 61.319C55.5901 64.3723 53.8075 68.01 52.9537 71.917C51.4417 76.8925 51.7658 82.2538 53.8659 87.0059C55.9661 91.758 59.6995 95.5781 64.3734 97.7571C66.9118 98.6888 69.5174 99.4217 72.1671 99.9491C72.3424 99.9993 72.5259 100.013 72.7065 99.9884C72.8871 99.9642 73.0608 99.9028 73.217 99.808C73.3732 99.7132 73.5086 99.587 73.6147 99.4373C73.7209 99.2876 73.7956 99.1174 73.8342 98.9374C74.4177 96.6189 70.8751 97.3355 65.4987 94.9328C61.6722 92.9399 58.6871 89.615 57.094 85.5711C55.5008 81.5272 55.4069 77.0371 56.8297 72.9287C57.619 69.7491 59.1452 66.8053 61.2821 64.3404C63.419 61.8756 66.1053 59.9606 69.1189 58.7538C72.1325 57.547 75.3868 57.0829 78.6128 57.4001C81.8388 57.7172 84.9438 58.8065 87.6712 60.5777C91.3984 63.1527 94.1367 66.9458 95.4268 71.3206C96.7168 75.6954 96.4801 80.3859 94.7564 84.6052C92.5892 89.9587 87.046 96.5768 81.1695 96.8297C79.169 96.8297 78.9606 101.34 86.0458 98.2629C91.2017 95.6077 95.3368 91.2918 97.7989 85.9963C100.112 80.9917 100.62 75.326 99.2345 69.9822C97.8489 64.6385 94.6573 59.954 90.2135 56.7417Z"
                      fill="#4072B7"
                    />
                    <path
                      d="M79.1678 70.3152C81.2871 72.78 82.902 75.6455 83.919 78.7459C83.919 79.1148 84.0639 79.4686 84.3219 79.7295C84.5798 79.9904 84.9296 80.1369 85.2944 80.1369C85.6592 80.1369 86.009 79.9904 86.2669 79.7295C86.5249 79.4686 86.6698 79.1148 86.6698 78.7459C86.3859 76.2964 85.725 73.9069 84.7109 71.6641C84.2108 70.6102 83.7106 69.725 83.0021 68.2918C82.4951 67.1637 81.7563 66.1578 80.8349 65.341C78.5843 63.7814 75.2501 65.341 73.2912 67.1115C70.7302 69.9385 68.7974 73.2876 67.6231 76.9333C67.543 77.0823 67.4946 77.2465 67.4807 77.4156C67.4668 77.5846 67.4879 77.7547 67.5425 77.915C67.5972 78.0753 67.6842 78.2224 67.7981 78.3469C67.912 78.4714 68.0502 78.5705 68.2041 78.638C68.3579 78.7055 68.5239 78.7399 68.6916 78.739C68.8593 78.7382 69.0249 78.702 69.178 78.6328C69.3311 78.5637 69.4683 78.4631 69.5809 78.3374C69.6935 78.2117 69.779 78.0637 69.832 77.9028C71.1592 75.4575 72.9097 73.2731 75 71.4533C75 72.5071 75 73.8561 75 74.1511C74.3604 77.4967 74.192 80.9169 74.4999 84.3101C74.4375 86.1328 74.5773 87.9568 74.9167 89.7479C74.9774 90.0665 75.1609 90.3477 75.4266 90.5295C75.6924 90.7113 76.0187 90.7789 76.3337 90.7174C76.6487 90.656 76.9267 90.4704 77.1065 90.2016C77.2862 89.9329 77.3531 89.6029 77.2923 89.2842C77.4945 87.705 77.8576 86.1511 78.3759 84.6473C79.1199 81.2726 79.289 77.7942 78.876 74.3619C78.4593 67.4909 78.2925 69.0506 79.1678 70.3152Z"
                      fill="#4072B7"
                    />
                    <path
                      d="M20.1537 21.7544C22.1876 22.4515 24.2802 22.9594 26.4053 23.2719C30.5503 23.8952 34.7637 23.8952 38.9086 23.2719C39.2734 23.2719 39.6232 23.1253 39.8812 22.8645C40.1391 22.6036 40.284 22.2498 40.284 21.8808C40.284 21.5119 40.1391 21.1581 39.8812 20.8972C39.6232 20.6363 39.2734 20.4898 38.9086 20.4898C34.8425 19.3353 30.627 18.8094 26.4053 18.9301C24.138 18.6988 21.848 18.899 19.6535 19.5202C19.1951 19.8575 18.9867 21.0377 20.1537 21.7544Z"
                      fill="#4072B7"
                    />
                    <path
                      d="M18.8204 38.1517C18.722 38.4162 18.7139 38.7064 18.7976 38.9761C18.8813 39.2458 19.0519 39.4793 19.2822 39.6394C19.5125 39.7995 19.7892 39.877 20.0681 39.8595C20.347 39.842 20.6121 39.7305 20.821 39.5427C24.7915 39.4639 28.7623 39.6894 32.6991 40.2172C42.5767 40.4701 49.3702 39.1634 56.7055 38.784C57.0344 38.7263 57.3326 38.553 57.5476 38.2946C57.7625 38.0363 57.8804 37.7095 57.8804 37.3718C57.8804 37.0342 57.7625 36.7074 57.5476 36.449C57.3326 36.1907 57.0344 36.0174 56.7055 35.9597C47.2056 35.158 37.6562 35.158 28.1562 35.9597C26.4058 36.2548 20.1541 35.9175 18.8204 38.1517Z"
                      fill="#4072B7"
                    />
                    <path
                      d="M43.9089 54.7602C37.0909 53.4732 30.0964 53.4732 23.2784 54.7602C19.9442 55.3082 19.4857 55.266 19.1106 55.6876C18.9082 55.837 18.7549 56.0446 18.6706 56.2833C18.5862 56.522 18.5748 56.7808 18.6377 57.0262C18.7006 57.2716 18.8349 57.4922 19.0233 57.6594C19.2117 57.8266 19.4454 57.9327 19.6941 57.9638C20.2352 58.0036 20.7785 58.0036 21.3195 57.9638C28.8509 59.0779 36.5025 59.0779 44.0339 57.9638C44.2419 57.9555 44.4462 57.9059 44.6352 57.8177C44.8242 57.7295 44.9942 57.6046 45.1355 57.45C45.2767 57.2954 45.3865 57.1141 45.4585 56.9166C45.5305 56.7191 45.5633 56.5091 45.5551 56.2988C45.5469 56.0884 45.4978 55.8818 45.4106 55.6906C45.3235 55.4994 45.1999 55.3275 45.0471 55.1846C44.8942 55.0418 44.715 54.9307 44.5197 54.8579C44.3244 54.7851 44.1168 54.7519 43.9089 54.7602Z"
                      fill="#4072B7"
                    />
                    <path
                      d="M41.2847 72.8444C29.5732 72.8444 16.8199 71.2847 5.10843 69.9358C11.1934 54.6341 10.5682 32.7985 12.4854 8.39167C12.4854 7.97014 13.3189 6.62123 13.694 6.53692C17.8618 5.56739 37.4503 2.82741 39.9927 2.70095C41.8441 2.55245 43.7069 2.738 45.4941 3.24895C47.0362 3.62833 49.9953 -0.123332 39.7843 0.0031284C37.492 0.0452819 15.5279 1.98434 12.0686 2.91172C8.60935 3.8391 8.526 6.19969 7.48406 15.5578C5.5252 43.6741 5.35849 50.9667 3.31629 60.9149C1.27408 70.8632 -0.684772 71.0739 0.232138 72.6336C0.388726 72.9446 0.619216 73.2114 0.902917 73.41C1.18662 73.6087 1.51465 73.733 1.85757 73.7717C14.1525 74.7413 28.9064 75.9216 41.2847 75.6686C41.6136 75.611 41.9118 75.4377 42.1268 75.1793C42.3417 74.921 42.4596 74.5942 42.4596 74.2565C42.4596 73.9189 42.3417 73.592 42.1268 73.3337C41.9118 73.0754 41.6136 72.9021 41.2847 72.8444Z"
                      fill="#4072B7"
                    />
                    <path
                      d="M61.7465 13.1549C63.2469 14.5881 65.9143 16.4007 66.6228 17.9604L66.206 44.2642C66.2591 44.5548 66.4112 44.8173 66.6358 45.0064C66.8604 45.1954 67.1433 45.2989 67.4355 45.2989C67.7277 45.2989 68.0106 45.1954 68.2352 45.0064C68.4598 44.8173 68.6119 44.5548 68.665 44.2642C68.665 41.9879 72.8328 20.1524 70.7906 15.8527C69.3319 12.9863 69.0401 13.9558 54.703 1.77345C54.4073 1.58391 54.0527 1.51177 53.7076 1.57094C53.3625 1.6301 53.0512 1.81637 52.8338 2.09386C52.6164 2.37135 52.5082 2.72041 52.5301 3.07376C52.5521 3.42712 52.7025 3.75977 52.9525 4.00759L61.7465 13.1549Z"
                      fill="#4072B7"
                    />
                    <path
                      d="M47.0367 21.3326C49.204 25.5479 56.706 23.7775 61.4572 22.4707C69.7928 20.1944 65.625 16.0634 63.9579 18.2554C59.8212 19.6497 55.3959 19.9258 51.1212 19.0563C50.7683 16.1625 50.8809 13.2301 51.4546 10.3727C51.788 5.77794 51.8297 5.86225 51.0795 5.60933C49.4957 4.93487 49.079 7.46408 48.4538 9.82468C47.6202 12.944 45.1196 17.4966 47.0367 21.3326Z"
                      fill="#4072B7"
                    />
                    <path
                      d="M73.4178 8.47589C75.5458 10.1893 77.4752 12.1408 79.1693 14.2931L76.7103 45.1494C76.7103 46.7934 77.8356 47.4679 78.7108 46.119C79.9612 42.3673 85.0042 15.1361 82.2951 11.258C78.8487 7.418 74.8769 4.09639 70.5003 1.39411C70.3651 1.251 70.2011 1.13875 70.0195 1.06486C69.8379 0.990971 69.6428 0.957142 69.4472 0.965636C69.2516 0.974131 69.0601 1.02475 68.8854 1.11412C68.7108 1.20348 68.557 1.32953 68.4343 1.48384C68.3116 1.63815 68.223 1.81716 68.1742 2.00891C68.1254 2.20065 68.1177 2.40072 68.1515 2.59573C68.1854 2.79075 68.2599 2.97621 68.3703 3.13973C68.4807 3.30325 68.6243 3.44105 68.7915 3.54394L73.4178 8.47589Z"
                      fill="#F6A405"
                    />
                  </svg>

                  <h2 class="text-gray font">Drag & Drop</h2>
                  <h5 class="text-gray font">
                    Your files here or
                    <a>Browse</a>
                    to upload
                  </h5>
                  <br />
                  <h5 class="text-gray font">
                    <a>CSV or Excel Files Only</a> <br />
                    <img
                      v-if="arrayLength"
                      src="/success.png"
                      width="30"
                      height="30"
                      alt=""
                    />
                  </h5>
                </div>
                <div
                  class="col-md-12 justify-center text-center row pb-0 mt-2"
                  v-if="arrayLength"
                >
                  <div class="col-md-11 pr-6 pl-6 text-center pb-0">
                    <v-alert type="success" outlined>
                      File uploaded successfully</v-alert
                    >
                  </div>
                </div>
                <div class="btn-box col-md-11 pb-0">
                  <div class="downoald-file-btn-box">
                    <h3>
                      <a class="underline-text" @click="downloadExcel"
                        >Download File Template</a
                      >
                    </h3>
                  </div>
                </div>
              </div>
            </v-col>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div class="col-md-12 mb-4" align="end">
            <span
              class="text-underline text-gray mr-10 pointer"
              @click="memberDialog = false"
              >Cancel</span
            >
            <span
              class="text-underline ml-10 mr-10 text-gray pointer"
              @click="uploadExcelItems"
              >Upload</span
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="uploadDialog" persistent max-width="800px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-col md="12" cols="12" class="justify-center align-center">
              <div class="row col-md-12 font">
                <h3 class="ml-3">Upload an Invoice</h3>
              </div>
              <div class="row text-center justify-center upload-box">
                <div
                  class="col-md-10 upload-provider-box pointer"
                  style="padding-bottom: 30px; padding-top: 50px"
                  @click="addItemExcelInvoices"
                >
                  <v-file-input
                    @change="Preview_pdf"
                    v-model.trim="dataComponents.pdf"
                    required
                    solo
                    style="display: none"
                    truncate-length="15"
                    ref="fileInput"
                  ></v-file-input>

                  <svg
                    width="100"
                    height="100"
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M90.2135 56.7417C86.921 54.5234 83.1435 53.1503 79.208 52.7413C75.2726 52.3322 71.2979 52.8996 67.6281 54.3942C63.9583 55.8889 60.704 58.2658 58.147 61.319C55.5901 64.3723 53.8075 68.01 52.9537 71.917C51.4417 76.8925 51.7658 82.2538 53.8659 87.0059C55.9661 91.758 59.6995 95.5781 64.3734 97.7571C66.9118 98.6888 69.5174 99.4217 72.1671 99.9491C72.3424 99.9993 72.5259 100.013 72.7065 99.9884C72.8871 99.9642 73.0608 99.9028 73.217 99.808C73.3732 99.7132 73.5086 99.587 73.6147 99.4373C73.7209 99.2876 73.7956 99.1174 73.8342 98.9374C74.4177 96.6189 70.8751 97.3355 65.4987 94.9328C61.6722 92.9399 58.6871 89.615 57.094 85.5711C55.5008 81.5272 55.4069 77.0371 56.8297 72.9287C57.619 69.7491 59.1452 66.8053 61.2821 64.3404C63.419 61.8756 66.1053 59.9606 69.1189 58.7538C72.1325 57.547 75.3868 57.0829 78.6128 57.4001C81.8388 57.7172 84.9438 58.8065 87.6712 60.5777C91.3984 63.1527 94.1367 66.9458 95.4268 71.3206C96.7168 75.6954 96.4801 80.3859 94.7564 84.6052C92.5892 89.9587 87.046 96.5768 81.1695 96.8297C79.169 96.8297 78.9606 101.34 86.0458 98.2629C91.2017 95.6077 95.3368 91.2918 97.7989 85.9963C100.112 80.9917 100.62 75.326 99.2345 69.9822C97.8489 64.6385 94.6573 59.954 90.2135 56.7417Z"
                      fill="#4072B7"
                    />
                    <path
                      d="M79.1678 70.3152C81.2871 72.78 82.902 75.6455 83.919 78.7459C83.919 79.1148 84.0639 79.4686 84.3219 79.7295C84.5798 79.9904 84.9296 80.1369 85.2944 80.1369C85.6592 80.1369 86.009 79.9904 86.2669 79.7295C86.5249 79.4686 86.6698 79.1148 86.6698 78.7459C86.3859 76.2964 85.725 73.9069 84.7109 71.6641C84.2108 70.6102 83.7106 69.725 83.0021 68.2918C82.4951 67.1637 81.7563 66.1578 80.8349 65.341C78.5843 63.7814 75.2501 65.341 73.2912 67.1115C70.7302 69.9385 68.7974 73.2876 67.6231 76.9333C67.543 77.0823 67.4946 77.2465 67.4807 77.4156C67.4668 77.5846 67.4879 77.7547 67.5425 77.915C67.5972 78.0753 67.6842 78.2224 67.7981 78.3469C67.912 78.4714 68.0502 78.5705 68.2041 78.638C68.3579 78.7055 68.5239 78.7399 68.6916 78.739C68.8593 78.7382 69.0249 78.702 69.178 78.6328C69.3311 78.5637 69.4683 78.4631 69.5809 78.3374C69.6935 78.2117 69.779 78.0637 69.832 77.9028C71.1592 75.4575 72.9097 73.2731 75 71.4533C75 72.5071 75 73.8561 75 74.1511C74.3604 77.4967 74.192 80.9169 74.4999 84.3101C74.4375 86.1328 74.5773 87.9568 74.9167 89.7479C74.9774 90.0665 75.1609 90.3477 75.4266 90.5295C75.6924 90.7113 76.0187 90.7789 76.3337 90.7174C76.6487 90.656 76.9267 90.4704 77.1065 90.2016C77.2862 89.9329 77.3531 89.6029 77.2923 89.2842C77.4945 87.705 77.8576 86.1511 78.3759 84.6473C79.1199 81.2726 79.289 77.7942 78.876 74.3619C78.4593 67.4909 78.2925 69.0506 79.1678 70.3152Z"
                      fill="#4072B7"
                    />
                    <path
                      d="M20.1537 21.7544C22.1876 22.4515 24.2802 22.9594 26.4053 23.2719C30.5503 23.8952 34.7637 23.8952 38.9086 23.2719C39.2734 23.2719 39.6232 23.1253 39.8812 22.8645C40.1391 22.6036 40.284 22.2498 40.284 21.8808C40.284 21.5119 40.1391 21.1581 39.8812 20.8972C39.6232 20.6363 39.2734 20.4898 38.9086 20.4898C34.8425 19.3353 30.627 18.8094 26.4053 18.9301C24.138 18.6988 21.848 18.899 19.6535 19.5202C19.1951 19.8575 18.9867 21.0377 20.1537 21.7544Z"
                      fill="#4072B7"
                    />
                    <path
                      d="M18.8204 38.1517C18.722 38.4162 18.7139 38.7064 18.7976 38.9761C18.8813 39.2458 19.0519 39.4793 19.2822 39.6394C19.5125 39.7995 19.7892 39.877 20.0681 39.8595C20.347 39.842 20.6121 39.7305 20.821 39.5427C24.7915 39.4639 28.7623 39.6894 32.6991 40.2172C42.5767 40.4701 49.3702 39.1634 56.7055 38.784C57.0344 38.7263 57.3326 38.553 57.5476 38.2946C57.7625 38.0363 57.8804 37.7095 57.8804 37.3718C57.8804 37.0342 57.7625 36.7074 57.5476 36.449C57.3326 36.1907 57.0344 36.0174 56.7055 35.9597C47.2056 35.158 37.6562 35.158 28.1562 35.9597C26.4058 36.2548 20.1541 35.9175 18.8204 38.1517Z"
                      fill="#4072B7"
                    />
                    <path
                      d="M43.9089 54.7602C37.0909 53.4732 30.0964 53.4732 23.2784 54.7602C19.9442 55.3082 19.4857 55.266 19.1106 55.6876C18.9082 55.837 18.7549 56.0446 18.6706 56.2833C18.5862 56.522 18.5748 56.7808 18.6377 57.0262C18.7006 57.2716 18.8349 57.4922 19.0233 57.6594C19.2117 57.8266 19.4454 57.9327 19.6941 57.9638C20.2352 58.0036 20.7785 58.0036 21.3195 57.9638C28.8509 59.0779 36.5025 59.0779 44.0339 57.9638C44.2419 57.9555 44.4462 57.9059 44.6352 57.8177C44.8242 57.7295 44.9942 57.6046 45.1355 57.45C45.2767 57.2954 45.3865 57.1141 45.4585 56.9166C45.5305 56.7191 45.5633 56.5091 45.5551 56.2988C45.5469 56.0884 45.4978 55.8818 45.4106 55.6906C45.3235 55.4994 45.1999 55.3275 45.0471 55.1846C44.8942 55.0418 44.715 54.9307 44.5197 54.8579C44.3244 54.7851 44.1168 54.7519 43.9089 54.7602Z"
                      fill="#4072B7"
                    />
                    <path
                      d="M41.2847 72.8444C29.5732 72.8444 16.8199 71.2847 5.10843 69.9358C11.1934 54.6341 10.5682 32.7985 12.4854 8.39167C12.4854 7.97014 13.3189 6.62123 13.694 6.53692C17.8618 5.56739 37.4503 2.82741 39.9927 2.70095C41.8441 2.55245 43.7069 2.738 45.4941 3.24895C47.0362 3.62833 49.9953 -0.123332 39.7843 0.0031284C37.492 0.0452819 15.5279 1.98434 12.0686 2.91172C8.60935 3.8391 8.526 6.19969 7.48406 15.5578C5.5252 43.6741 5.35849 50.9667 3.31629 60.9149C1.27408 70.8632 -0.684772 71.0739 0.232138 72.6336C0.388726 72.9446 0.619216 73.2114 0.902917 73.41C1.18662 73.6087 1.51465 73.733 1.85757 73.7717C14.1525 74.7413 28.9064 75.9216 41.2847 75.6686C41.6136 75.611 41.9118 75.4377 42.1268 75.1793C42.3417 74.921 42.4596 74.5942 42.4596 74.2565C42.4596 73.9189 42.3417 73.592 42.1268 73.3337C41.9118 73.0754 41.6136 72.9021 41.2847 72.8444Z"
                      fill="#4072B7"
                    />
                    <path
                      d="M61.7465 13.1549C63.2469 14.5881 65.9143 16.4007 66.6228 17.9604L66.206 44.2642C66.2591 44.5548 66.4112 44.8173 66.6358 45.0064C66.8604 45.1954 67.1433 45.2989 67.4355 45.2989C67.7277 45.2989 68.0106 45.1954 68.2352 45.0064C68.4598 44.8173 68.6119 44.5548 68.665 44.2642C68.665 41.9879 72.8328 20.1524 70.7906 15.8527C69.3319 12.9863 69.0401 13.9558 54.703 1.77345C54.4073 1.58391 54.0527 1.51177 53.7076 1.57094C53.3625 1.6301 53.0512 1.81637 52.8338 2.09386C52.6164 2.37135 52.5082 2.72041 52.5301 3.07376C52.5521 3.42712 52.7025 3.75977 52.9525 4.00759L61.7465 13.1549Z"
                      fill="#4072B7"
                    />
                    <path
                      d="M47.0367 21.3326C49.204 25.5479 56.706 23.7775 61.4572 22.4707C69.7928 20.1944 65.625 16.0634 63.9579 18.2554C59.8212 19.6497 55.3959 19.9258 51.1212 19.0563C50.7683 16.1625 50.8809 13.2301 51.4546 10.3727C51.788 5.77794 51.8297 5.86225 51.0795 5.60933C49.4957 4.93487 49.079 7.46408 48.4538 9.82468C47.6202 12.944 45.1196 17.4966 47.0367 21.3326Z"
                      fill="#4072B7"
                    />
                    <path
                      d="M73.4178 8.47589C75.5458 10.1893 77.4752 12.1408 79.1693 14.2931L76.7103 45.1494C76.7103 46.7934 77.8356 47.4679 78.7108 46.119C79.9612 42.3673 85.0042 15.1361 82.2951 11.258C78.8487 7.418 74.8769 4.09639 70.5003 1.39411C70.3651 1.251 70.2011 1.13875 70.0195 1.06486C69.8379 0.990971 69.6428 0.957142 69.4472 0.965636C69.2516 0.974131 69.0601 1.02475 68.8854 1.11412C68.7108 1.20348 68.557 1.32953 68.4343 1.48384C68.3116 1.63815 68.223 1.81716 68.1742 2.00891C68.1254 2.20065 68.1177 2.40072 68.1515 2.59573C68.1854 2.79075 68.2599 2.97621 68.3703 3.13973C68.4807 3.30325 68.6243 3.44105 68.7915 3.54394L73.4178 8.47589Z"
                      fill="#F6A405"
                    />
                  </svg>

                  <h2 class="text-gray font">Drag & Drop</h2>
                  <h5 class="text-gray font">
                    Your files here or
                    <a>Browse</a>
                    to upload
                  </h5>
                  <br />
                  <h5 class="text-gray font">
                    <a>PDF FIle Only</a> <br />
                    <img
                      v-if="pdfsLength"
                      src="/success.png"
                      width="30"
                      height="30"
                      alt=""
                    />
                  </h5>
                </div>
                <div
                  class="col-md-12 justify-center text-center row pb-0 mt-2"
                  v-if="pdfsLength"
                >
                  <div class="col-md-11 pr-6 pl-6 text-center pb-0">
                    <v-alert type="success" outlined>
                      File uploaded successfully</v-alert
                    >
                  </div>
                </div>
              </div>
            </v-col>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div class="col-md-12 mb-4" align="end">
            <span
              class="text-underline text-gray mr-10 pointer"
              @click="cancelUploading"
              >Cancel</span
            >
            <span
              class="text-underline ml-10 mr-10 text-gray pointer"
              @click="uploadDialog = false"
              >Upload</span
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="emailDialog" persistent max-width="800px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-col md="12" cols="12" class="justify-center align-center">
              <div class="row col-md-12 font">
                <h3 class="ml-3">Email an Invoice</h3>
              </div>
              <div class="row text-center justify-center upload-box">
                <div
                  class="col-md-10 upload-provider-box pointer"
                  style="padding-bottom: 10px; padding-top: 50px"
                  @click="addItemExcel"
                >
                  <!-- <input
                    ref="fileInput"
                    type="file"
                    style="display: none"
                    @change="uploadExcel"
                  /> -->
                  <svg
                    width="100"
                    height="100"
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M98.1645 18.3489C97.645 17.8998 97.0281 17.6034 96.3729 17.4881C95.5548 17.418 94.7328 17.418 93.9146 17.4881L86.3315 18.3036C82.1649 18.666 77.9984 18.8925 73.4985 18.9831C67.0403 18.9831 56.0823 17.6693 54.1657 18.9831C52.5711 21.3799 51.2556 23.9821 50.2491 26.7304L41.916 42.9952C40.9664 44.8515 40.2783 46.8521 39.8744 48.9303C39.7191 49.8136 39.8249 50.7276 40.1767 51.5415C40.5285 52.3553 41.1081 53.0272 41.8326 53.4609C42.5291 53.8106 43.2765 54.0253 44.0409 54.0952C45.1789 54.1634 46.3195 54.1634 47.4575 54.0952H56.4156C63.3321 54.0952 70.3736 55.2278 77.2484 55.5449C80.3294 55.7262 83.4172 55.7262 86.4982 55.5449C87.2362 55.4673 87.95 55.2165 88.5902 54.8097C89.2304 54.403 89.7818 53.8501 90.2064 53.189C91.2394 51.2758 92.0643 49.2384 92.6647 47.1181L98.9562 28.5427C99.5545 26.7513 99.9056 24.8733 99.9978 22.9701C100.022 22.1008 99.8708 21.2363 99.554 20.4377C99.2372 19.6391 98.7628 18.926 98.1645 18.3489ZM73.5402 22.6529C77.7067 22.6529 82.2066 22.6529 86.5398 22.6529L90.4981 22.3358L77.4151 32.0765C76.4984 32.7561 74.9151 34.2512 73.2485 35.3385C72.4985 35.8369 71.8735 36.3353 71.2902 36.1994L68.9153 33.4357L60.9988 24.9635C60.4988 24.3745 59.6655 23.1513 58.7072 22.1546C63.7071 22.3358 68.6236 22.6529 73.5402 22.6529ZM95.8313 23.559C95.6487 24.7759 95.3268 25.963 94.873 27.0929L88.2065 45.5777C87.9565 46.2573 86.7065 48.6132 86.1232 50.1082C86.0574 50.2916 85.9432 50.4497 85.7949 50.5626C85.6466 50.6755 85.4708 50.7381 85.2899 50.7425C82.6649 50.7425 79.9983 50.7425 77.3317 50.7425C70.2902 50.3348 63.2071 49.4287 56.2489 49.2474H44.1659C44.5977 47.8758 45.1561 46.5552 45.8325 45.3058C45.8325 45.3058 55.7073 26.5039 55.9989 25.2354L66.6653 36.2447C67.1653 36.743 68.0403 37.921 68.9153 38.7365C69.4806 39.2958 70.1697 39.6861 70.9152 39.8691C72.1743 40.0026 73.4377 39.6671 74.4985 38.9177C76.1162 37.7419 77.674 36.4715 79.165 35.112C79.165 35.112 94.8313 22.6076 95.8313 21.5203C95.9661 21.8401 96.0359 22.1878 96.0359 22.5397C96.0359 22.8915 95.9661 23.2392 95.8313 23.559Z"
                      fill="#0C6FFF"
                    />
                    <path
                      d="M33.5382 27.9991C33.9177 27.9873 34.278 27.8151 34.5426 27.519C34.8071 27.2228 34.955 26.8262 34.9549 26.4134C34.9504 26.1928 34.9037 25.9757 34.8176 25.7759C34.7316 25.5761 34.6082 25.398 34.4552 25.253C34.3023 25.108 34.1232 24.9994 33.9294 24.9339C33.7357 24.8685 33.5315 24.8477 33.3299 24.873C26.3717 23.9669 16.247 25.5526 15.997 27.1383C15.9363 27.5048 16.012 27.8825 16.2073 28.1883C16.4026 28.4942 16.7017 28.7031 17.0387 28.7693C24.9968 31.7142 29.1633 28.8599 33.5382 27.9991Z"
                      fill="#0C6FFF"
                    />
                    <path
                      d="M11.873 39.8243C11.8833 40.0071 11.9275 40.1857 12.003 40.3494C12.0784 40.5132 12.1835 40.6586 12.3119 40.7771C12.4403 40.8956 12.5894 40.9846 12.7503 41.0389C12.9111 41.0932 13.0804 41.1115 13.2479 41.0928C15.9979 41.0928 18.7061 41.5912 21.5811 41.6818C22.7477 41.6818 23.9143 41.6818 25.081 41.6818L28.5809 41.3647C31.3308 41.0928 34.0391 40.6851 36.914 40.3679C37.3008 40.3679 37.6717 40.2009 37.9452 39.9035C38.2187 39.6061 38.3723 39.2028 38.3723 38.7822C38.3723 38.3617 38.2187 37.9584 37.9452 37.661C37.6717 37.3636 37.3008 37.1965 36.914 37.1965C34.1641 36.9247 31.4141 36.5623 28.5809 36.381C27.2059 36.2451 26.0393 36.2451 24.9976 36.2451C23.956 36.2451 22.6227 36.2451 21.4561 36.517C18.6228 36.9247 15.9562 37.6043 13.1229 38.2386C12.9397 38.2358 12.7581 38.2768 12.5911 38.3588C12.4241 38.4408 12.2757 38.5618 12.1564 38.7131C12.0371 38.8644 11.9499 39.0423 11.9009 39.2344C11.852 39.4264 11.8424 39.6278 11.873 39.8243Z"
                      fill="#0C6FFF"
                    />
                    <path
                      d="M28.8326 62.4767C22.8328 62.4767 16.3329 61.5253 10.3747 62.0237C9.41643 62.0237 8.37479 62.0237 7.41648 62.0237C6.79149 58.4445 6.16651 54.9106 5.66652 51.3315C5.26872 48.3277 5.01838 45.3031 4.91654 42.2703C4.91654 38.5099 4.91654 34.7496 4.91654 31.0345C4.91654 27.3194 5.45819 23.559 5.91652 19.7986C6.0469 18.1271 6.32597 16.4733 6.74983 14.8603C7.04901 13.6144 7.72388 12.5137 8.66644 11.7342C10.5717 10.4456 12.6746 9.54015 14.8746 9.06116C18.4091 8.16934 21.9831 7.47376 25.5827 6.9771C29.7492 6.2069 34.2491 5.66323 38.5823 5.21017C45.1238 4.53058 51.707 4.03222 58.3318 3.62446C61.2068 3.62446 64.165 3.30732 67.04 3.39794C68.9566 3.39794 70.8732 3.53385 72.7898 3.80569C73.8116 3.90853 74.8271 4.07493 75.8314 4.30405C76.414 4.41948 76.9764 4.63351 77.498 4.93833C78.6431 5.49742 79.6341 6.37198 80.3729 7.47546C80.8921 8.77532 81.1478 10.1814 81.1229 11.5983C81.1444 11.9628 81.2956 12.3039 81.5446 12.5492C81.7935 12.7945 82.1205 12.9247 82.4562 12.9122C82.6241 12.9065 82.7892 12.8641 82.9416 12.7875C83.0941 12.7109 83.2308 12.6017 83.3436 12.4664C83.4564 12.331 83.5429 12.1724 83.5981 11.9999C83.6532 11.8274 83.6758 11.6446 83.6645 11.4624C83.725 9.60949 83.3973 7.76592 82.7062 6.07098C81.7673 4.46133 80.4418 3.16109 78.873 2.3106C78.1283 1.85877 77.3288 1.52324 76.498 1.31387C75.3731 0.996728 74.2064 0.86081 73.1648 0.679587C71.2065 0.362446 68.9982 0.181223 67.165 0.0453058C64.1234 -4.21943e-08 61.1234 0 58.3318 0C51.6653 0 45.0405 0.362446 38.4157 0.815504C33.9991 1.13265 29.5409 1.5404 25.1244 2.21999C21.4578 2.76365 17.5412 3.1261 13.8746 4.07752C11.2146 4.75917 8.67921 5.9232 6.37484 7.52077C4.88102 8.6565 3.71144 10.2266 2.99992 12.0513C2.13621 14.3428 1.56156 16.7507 1.29163 19.2097C0.791646 23.0607 0.458322 26.9117 0.249994 30.808C0.0416656 34.7043 0 38.6006 0 42.4969C0.087691 45.7296 0.366033 48.953 0.833312 52.147C1.4583 56.6776 2.4166 61.48 3.24992 66.1465C3.59799 68.5989 4.24244 70.9906 5.16653 73.2595C5.94069 75.1093 7.18365 76.6809 8.74978 77.7901C11.2079 79.2462 13.8914 80.1983 16.6662 80.599C20.572 81.21 24.5117 81.5279 28.4576 81.5505C32.0408 81.5505 35.6241 81.5505 39.2073 81.5505C38.5103 83 37.9385 84.5167 37.499 86.081C37.2237 87.364 37.0288 88.6657 36.9157 89.9773C36.9157 91.8802 36.9157 93.5565 36.6241 94.8251C33.0825 95.2781 29.5826 95.8671 26.166 96.5467C25.8644 96.6316 25.6013 96.8322 25.425 97.1115C25.2487 97.3908 25.1711 97.7299 25.2067 98.0664C25.2422 98.4029 25.3883 98.7142 25.6182 98.9428C25.8481 99.1714 26.1462 99.3019 26.4577 99.3103C29.1243 99.3103 31.8742 99.3103 34.7908 99.3103L40.8323 99.6728C42.8739 99.6728 44.9989 99.6728 46.8738 99.8993C48.7488 100.126 50.707 99.8993 52.7486 99.8993C56.9152 99.8993 61.5818 99.0838 66.165 98.7214C66.5445 98.7096 66.9048 98.5373 67.1693 98.2412C67.4339 97.9451 67.5818 97.5485 67.5816 97.1357C67.5816 96.7151 67.428 96.3118 67.1545 96.0144C66.881 95.717 66.5101 95.55 66.1233 95.55L56.7902 95.1422C56.7902 93.8283 56.4986 92.2426 56.2069 90.6116C55.985 89.2764 55.6787 87.9594 55.2903 86.67C54.6727 84.8984 53.9201 83.1859 53.0403 81.5505C78.0397 81.0521 81.5812 82.7737 82.9562 75.5701C85.9978 59.26 83.5395 63.4281 28.8326 62.4767ZM50.4987 86.8512C50.6198 87.6958 50.8009 88.5289 51.0404 89.3431C51.2465 90.1589 51.4969 90.9607 51.7903 91.7443C52.207 92.8316 52.6237 93.783 52.9986 94.6891L47.0821 94.4173C44.8739 94.4173 42.6239 94.4173 40.3323 94.4173C40.7805 93.3098 41.17 92.1753 41.4989 91.0194C41.7567 90.2233 41.9519 89.4049 42.0823 88.5729C42.2382 87.7516 42.3358 86.9186 42.3739 86.081C42.3739 84.2235 42.3739 82.5472 42.3739 81.2786H50.0404C50.2071 82.6831 50.2071 84.6313 50.4987 86.8512ZM79.998 74.664C79.8721 75.5627 79.4766 76.3909 78.873 77.0199H75.7481C73.9981 77.0199 72.2065 77.0199 70.4565 77.0199H62.3317H42.0406C37.499 77.0199 33.0825 77.0199 28.5826 76.7481C24.8877 76.7125 21.1991 76.4098 17.5412 75.8419C15.3035 75.4574 13.1539 74.6116 11.208 73.3501C10.4076 72.7773 9.78356 71.9566 9.41643 70.9942C8.90585 69.7345 8.54193 68.4104 8.33312 67.0526C15.1348 66.9421 21.9369 67.2446 28.7076 67.9587L57.0402 68.8648C61.5818 69.1367 66.5816 68.8648 71.4565 69.182C73.8459 69.354 76.2246 69.6717 78.5813 70.1334H80.0396C80.1782 71.6407 80.1642 73.16 79.998 74.664Z"
                      fill="#191919"
                    />
                  </svg>
                  <br /><br />

                  <h2 class="text-gray font">Email your PDF Invoices to:</h2>
                  <h2 class="text-gray font">vendorEIN @invoices.apaly.net</h2>

                  <br /><br />

                  <h5 class="text-gray font">
                    <a>PDF FIle Email Attachments Only</a> <br />
                    <img
                      v-if="arrayLength"
                      src="/success.png"
                      width="30"
                      height="30"
                      alt=""
                    />
                  </h5>
                </div>
                <div
                  class="col-md-12 justify-center text-center row pb-0 mt-2"
                  v-if="arrayLength"
                >
                  <div class="col-md-11 pr-6 pl-6 text-center pb-0">
                    <v-alert type="success" outlined>
                      File uploaded successfully</v-alert
                    >
                  </div>
                </div>
              </div>
            </v-col>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div class="col-md-12 mb-4" align="end">
            <span
              class="text-underline text-gray mr-10 pointer"
              @click="emailDialog = false"
              >Cancel</span
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <successModal ref="success_modal" v-on:confirm="updateModal"></successModal>
  </div>
</template>
<script>
import Header from "../../DigitalVendorInvoices/Layout/HeaderPage.vue";
import api from "../../../../services/api";
import successModal from "../../../TablesTemplate/SuccessDialog.vue";
import XLSX from "xlsx";
import pdf from "jspdf";
import { jsPDF } from "jspdf";
export default {
  data() {
    return {
      item: null,
      tab: "invoice",
      uploadDialog: false,
      arrayLength: false,
      emailDialog: false,
      memberDialog: false,
      billingPeriod: "",
      uploadDialog: false,
      arrayLength: false,
      emailDialog: false,
      memberDialog: false,
      invoiceNo: "",
      startDate: "",
      endDate: "",
      clients: [],
      client: "",
      planId: "",
      total: "",
      valid: false,
      uploadedFile: null,
      pdfEvent: null,
      pdfsLength: false,
      membersList: [],
      pdfs: [],
      arrayExcel: [],
      filterArray: [],
      excelError: false,
      jsondata: [
        {
          memberId: "",
        },
        {
          serviceDay: "",
        },
        {
          serviceMonth: "",
        },
        {
          serviceYear: "",
        },

        {
          amount: "",
        },
      ],
      uploadedExcelItems: [],
      membersFromExcel: [],
      filterArray1: [],
      member: {
        memberId: "",
        serviceDate: "",
        amount: 0,
      },
      dataComponents: {
        pdf: {
          name: "",
        },
      },
      rules: [
        (v) =>
          (v && v.length > 4) ||
          "The invoice should contain more than 4 digits",
      ],
    };
  },
  components: { Header, successModal },
  computed: {},
  created() {
    this.item = this.$store.state.Invoicing.singleSoulution;
    this.getClients();
  },
  methods: {
    uploadExcelItems() {
      this.memberDialog = false;
      this.uploadedExcelItems = this.membersFromExcel;

      // this.membersList = this.uploadedExcelItems;
    },

    addMember() {
      let mem = this.member;
      this.membersList.push(mem);
      this.filterArray.push(mem);
      this.member = {
        memberId: "",
        serviceDate: "",
        amount: 0,
      };
    },
    Preview_pdf(event) {
      this.pdfEvent = event;
      this.pdfs.push(this.pdfEvent);
      if (this.pdfEvent) {
        this.pdfsLength = true;
      }
    },
    updateModal() {
      this.$router.push("/solution-vendor/invoices");
    },
    cancelUploading() {
      this.pdfs = [];
      this.pdfsLength = false;
      (this.dataComponents = {
        pdf: {
          name: "",
        },
      }),
        (this.uploadDialog = false);
    },
    getClients() {
      api()
        .get(`/vendors/clients`)
        .catch((err) => {
          this.load = false;
        })
        .then((res) => {
          if (res && res.data) {
            this.clients = res.data;
          }
        });
    },
    uploadInvoice() {
      this.uploadDialog = true;
    },

    submit() {
      this.$refs.form.validate();
      if (this.valid) {
        if (this.invoiceNo.length > 4) {
          let data = null;
          let formData = new FormData();
          if (this.tab == "members") {
            data = {
              invoiceNo: this.invoiceNo,
              startDate: this.startDate,
              endDate: this.endDate,
              client: this.client,
              planId: this.planId,
              total: this.total,
              list: this.membersList,
            };
          } else {
            formData.append("_method", "POST");
            formData.append("attachment", this.pdfEvent);
            formData.append("invoiceNo", this.invoiceNo);
            formData.append("startDate", this.startDate);
            formData.append("endDate", this.endDate);
            formData.append("client", this.client);
            formData.append("planId", this.planId);
            formData.append("total", this.total);
          }

          api()
            .post(`/vendors/invoices`, this.tab == "members" ? data : formData)
            .catch((err) => {
              this.load = false;
            })
            .then((response) => {
              if (response && response.data) {
                this.$refs.success_modal.openPopUp("Invoice added successfuly");
                this.$parent.getData();
              }
            });
        }
      }
    },

    remove(item) {
      let indx = this.membersList.findIndex((c) => c == item);
      this.membersList.splice(indx, 1);

      let indx1 = this.filterArray.findIndex((c) => c == item);
      this.filterArray.splice(indx1, 1);
    },
    removeFromExcel(item) {
      let indx = this.uploadedExcelItems.findIndex((c) => c == item);
      this.uploadedExcelItems.splice(indx, 1);

      let indx1 = this.filterArray1.findIndex((c) => c == item);
      this.filterArray1.splice(indx1, 1);
    },
    downloadExcel() {
      const data = XLSX.utils.json_to_sheet(this.jsondata);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, "memberTemplate.xlsx");
    },
    addItemExcelInvoices() {
      this.$refs.fileInput.$refs.input.click();
    },
    addItemExcel() {
      this.$refs.fileInput.click();
    },
    uploadExcel(e) {
      this.excelError = false;
      const files = e.target.files;

      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx|csv)$/.test(files[0].name.toLowerCase())) {
        return alert(
          "The upload format is incorrect. Please upload xls, xlsx or csv format"
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;

          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0];

          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);

          for (var i = 0; i < ws.length; i++) {
            if (ws[i]) {
              this.excelError = false;
              this.membersFromExcel.push(ws[i]);
              this.filterArray1.push(ws[i]);
              this.arrayLength = true;
            } else {
              this.excelError = true;
              this.arrayLength = false;
            }
          }

          if (this.membersFromExcel.length < 1) {
            this.arrayLength = false;
            this.$refs.error_modal.openPopUp(
              "Something Went Wrong, Please Download The File Template First"
            );
          }
        } catch (e) {
          return alert("Read failure! Please Download the File Template.");
        }
      };

      fileReader.readAsBinaryString(files[0]);
    },

    searchMembers(val) {
      this.membersList = this.filterArray.filter((el) => {
        if (el.memberId.toString().toLowerCase().includes(val.toLowerCase())) {
          return el.memberId
            .toString()
            .toLowerCase()
            .includes(val.toLowerCase());
        }
      });
      this.uploadedExcelItems = this.filterArray1.filter((el) => {
        if (el.memberId.toString().toLowerCase().includes(val.toLowerCase())) {
          return el.memberId
            .toString()
            .toLowerCase()
            .includes(val.toLowerCase());
        }
      });
    },
  },
};
</script>
<style>
.original-image-div {
  border: 1px solid rgb(219, 217, 217);
  min-height: 50vh;
}
.original-image-div .first {
  display: flex;
  min-height: 44vh;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.original-image-div .second {
  align-items: end;
  justify-content: end;
  text-align: end;
}
</style>
